const ITEMS = ["Pre-loved", "One of One", "Curated Archive", "No Restocks", "Circular Fashion", "JFLY®"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="select-none overflow-hidden border-y-2 border-[#F5F2EB] bg-[#FF3B1F] py-4">
      <div className="flex w-max animate-marquee gap-16 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-16 text-xs font-mono font-medium uppercase tracking-[0.35em] text-[#F5F2EB]">
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-[#0A0A0A]" />
          </span>
        ))}
      </div>
    </div>
  );
};
